"use client";

import { usePathname } from "next/navigation";

export function CarpetBackground() {
  const pathname = usePathname();

  // Get the first segment of the path (removing route groups)
  const segments = pathname?.split("/").filter(Boolean) || [];
  const routeSegments = segments.filter((segment) => !segment.startsWith("("));
  const currentRoute = routeSegments[0];

  // Hibernation: lobby + sunset rooms run the cosmic carpet (drifting Pokus
  // + a far mandorla on a starfield) so the whole arcade reads as the same
  // dark theater. Routes with bespoke functional carpets keep theirs.
  const COSMIC_CARPET = "/lobby/backdrop/cosmic-carpet.png";

  const routeAssetMap: Record<string, string> = {
    art: "/carpet/art.svg",
    incinerator: COSMIC_CARPET,
    lock: COSMIC_CARPET,
    mememaker: "/carpet/mememaker.svg",
    vault: COSMIC_CARPET,
    wall: COSMIC_CARPET,
    swap: "/carpet/default.svg",
    lobby: COSMIC_CARPET,
  };

  const backgroundPattern = currentRoute
    ? routeAssetMap[currentRoute] || COSMIC_CARPET
    : COSMIC_CARPET;

  const isCosmic = backgroundPattern === COSMIC_CARPET;

  return (
    <>
      {/* Black canvas — ensures the carpet sits on true black, not theme bg */}
      <div className="pointer-events-none fixed inset-0 z-[-3]" style={{ background: "#050507" }} />

      {/* Carpet — cosmic backdrop fills the viewport like a movie theater
          ceiling; the legacy SVG carpets keep their existing tile behavior. */}
      <div
        className="pointer-events-none fixed inset-0 z-[-2]"
        style={
          isCosmic
            ? {
                backgroundImage: `url('${backgroundPattern}')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center top",
                backgroundSize: "cover",
                opacity: 0.55,
              }
            : {
                backgroundImage: `url('${backgroundPattern}')`,
                backgroundRepeat: "repeat",
                backgroundSize: "300px 300px",
                backgroundPosition: "0 0",
                opacity: 0.2,
              }
        }
      />

      {/* Cosmic accent — distant starlight wash from top center, nostalgia
          fade at the bottom edge so content reads against a dimmed floor. */}
      {isCosmic ? (
        <div
          className="pointer-events-none fixed inset-0 z-[-1]"
          style={{
            background: `
              radial-gradient(120% 70% at 50% 0%, rgba(62, 97, 250, 0.10) 0%, transparent 55%),
              radial-gradient(140% 100% at 50% 100%, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 60%),
              radial-gradient(circle at center, transparent 35%, rgba(0,0,0,0.55) 100%)
            `,
          }}
        />
      ) : (
        <div
          className="pointer-events-none fixed inset-0 z-[-1]"
          style={{
            background: "radial-gradient(circle at center, transparent 50%, rgba(0,0,0,0.3) 100%)",
          }}
        />
      )}
    </>
  );
}
